import { ApolloClient, ApolloLink, gql, HttpLink, InMemoryCache } from "apollo-boost";
import { logout } from "../rest";

// You should use an absolute URL here
const httpLink = new HttpLink({
    uri: `${import.meta.env.VITE_APP_API_URL}/graphql`,
});

const errorLink = new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
        if (response.errors?.find((error) => error.message.toLowerCase() === "invalid token.")) {
            logout();
            throw new Error("Your token has expired. Please login again.");
        }
        return response;
    });
});

function getToken() {
    return localStorage.getItem("xcube-session-key");
}

export const apolloClient = new ApolloClient({
    link: ApolloLink.from([errorLink, httpLink]),
    cache: new InMemoryCache(),
});

export function getApolloOptions() {
    return {
        fetchPolicy: "no-cache",
        errorPolicy: "none",
        context: {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        },
    };
}
